class ProductItem extends HTMLElement {
  selectedClass = 'collection-product-card__variants-color-selected';
  constructor() {
    super();

    this.initProductSwiper();

    this.mediaList = this.querySelectorAll('.collection-card__media');
    this.variantsOptions = this.querySelectorAll('.collection-product-card__variants-color');
    this.cover = this.querySelector('.collection-card__media-cover');

    if (this.cover) {
      this.cover.addEventListener('mouseenter', this.onCoverMouseEnter.bind(this));
      this.cover.addEventListener('mouseleave', this.onCoverMouseOut.bind(this));
    }

    if (this.variantsOptions) {
      this.variantsOptions.forEach((option) => {
        // option.addEventListener('click', );
        option.addEventListener('mouseenter', this.onVariantClick.bind(this));
      });
    }
  }

  onCoverMouseEnter(event) {
    const front = this.cover.querySelector('.collection-card__media-image');
    const back = this.cover.querySelector('.collection-card__media-image-back');
    if (back.classList.contains('hidden')) {
      back.classList.remove('hidden');
      front.classList.add('hidden');
    }
  }

  onCoverMouseOut(event) {
    const front = this.cover.querySelector('.collection-card__media-image');
    const back = this.cover.querySelector('.collection-card__media-image-back');

    if (front.classList.contains('hidden')) {
      back.classList.add('hidden');
      front.classList.remove('hidden');
    }
  }

  initProductSwiper() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  hiddenAllMedia() {
    this.mediaList.forEach((media) => {
      if (!media.classList.contains('hidden')) {
        media.classList.add('hidden');
      }
    });
  }

  removeAllColorSelected() {
    this.variantsOptions.forEach((option) => {
      option.classList.remove(this.selectedClass);
    });
  }

  onVariantClick(event) {
    const targetId = event.target.dataset.target;
    this.hiddenAllMedia();
    if (!this.cover.classList.contains('hidden')) {
      this.cover.classList.add('hidden');
    }

    const elem = this.querySelector(`#${targetId}`);
    if (elem) {
      elem.classList.remove('hidden');
    }

    const variantUrl = elem.dataset.url;

    if (!event.target.classList.contains(this.selectedClass)) {
      this.removeAllColorSelected();
      event.target.classList.add(this.selectedClass);
    }

    // this.querySelector('.collection-product-card__title a').setAttribute('href', variantUrl);
    this.querySelectorAll('a').forEach((item) => {
      item.setAttribute('href', variantUrl);
    });
  }
}

customElements.define('product-item', ProductItem);
